import { OrganizationCountry } from "../enums/country";
import { donationFormCanGenerateReceipt, ticketingCanGenerateReceipt } from "./receipt";
const formAskForAddress = (country, { formGenerateReceipt, askForAddress }) => {
    if (country === OrganizationCountry.UnitedStates) {
        return Boolean(askForAddress);
    }
    if (country === OrganizationCountry.Canada ||
        country === OrganizationCountry.Australia ||
        country === OrganizationCountry.Germany) {
        if (formGenerateReceipt) {
            return true;
        }
        else {
            return askForAddress;
        }
    }
    if (country === OrganizationCountry.GreatBritain) {
        return Boolean(askForAddress);
    }
    return askForAddress;
};
export const donationFormAskForAddress = (donationForm, organization) => {
    const formGenerateReceipt = donationFormCanGenerateReceipt(donationForm, organization);
    return formAskForAddress(organization.country, { formGenerateReceipt, askForAddress: donationForm.askForAddress });
};
export const ticketingAskForAddress = (ticketing, rates, organization) => {
    const formGenerateReceipt = ticketingCanGenerateReceipt(ticketing, rates, organization);
    return formAskForAddress(organization.country, { formGenerateReceipt, askForAddress: ticketing.askForAddress });
};
export const isAddressMandatory = (organization, formHasReceipt) => {
    // If the organization can generate receipts and receipts are enabled on the form, we need to ask for the address
    if (organization?.country === OrganizationCountry.Canada ||
        organization?.country === OrganizationCountry.Australia ||
        organization?.country === OrganizationCountry.Germany) {
        return Boolean(organization?.canGenerateReceipt && formHasReceipt);
    }
    // GB: If the organization has a connected Swiftaid account, we need to ask for the address
    if (organization?.country === OrganizationCountry.GreatBritain) {
        return Boolean(organization?.hasConnectedSwiftaidAtUtc);
    }
    return false;
};
export const mustDisplayAddressQuestion = ({ displayGenerateReceipt, organization, hasGiftAidConfirmation, formData, }) => {
    // If the organization can generate receipts and receipts are enabled on the form, we need to ask for the address
    if (organization?.country === OrganizationCountry.Canada ||
        organization?.country === OrganizationCountry.Australia ||
        organization?.country === OrganizationCountry.Germany) {
        if (displayGenerateReceipt) {
            return true;
        }
        return Boolean(formData.askForAddress);
    }
    // GB: If the organization has a connected Swiftaid account, we need to ask for the address
    if (organization?.country === OrganizationCountry.GreatBritain) {
        if (hasGiftAidConfirmation) {
            return true;
        }
        return Boolean(formData.askForAddress);
    }
    if (organization?.country === OrganizationCountry.UnitedStates ||
        organization?.country === OrganizationCountry.Ireland) {
        return Boolean(formData.askForAddress);
    }
    return false;
};
export const askForRegion = (country) => {
    return (country === OrganizationCountry.UnitedStates ||
        country === OrganizationCountry.Canada ||
        country === OrganizationCountry.Australia);
};
export const isAddressMandatoryToGenerateReceipt = (country) => {
    return (country === OrganizationCountry.Canada ||
        country === OrganizationCountry.Australia ||
        country === OrganizationCountry.Germany);
};
